import React, { useState, useEffect, useCallback } from 'react';
import './Testimonials.css';

const testimonials = [
  {
    id: 1,
    name: 'Rajesh Manglani',
    role: 'Businessman',
    location: 'Greater Noida',
    property: 'Bought – 4 BHK Villa, Krishna Vatika',
    review: 'PACompany made my property buying experience absolutely seamless. The team guided me through every step — from site visits to registration. I got my dream 4 BHK villa at Krishna Vatika at the best price. I cannot recommend them highly enough for their dedication and professionalism.',
    rating: 5,
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    tag: '4 BHK Villa',
  },
  {
    id: 2,
    name: 'Priya Sharma',
    role: 'IT Professional',
    location: 'Noida Extension',
    property: 'Invested – Studio Apartment, Paradise Greens Plaza',
    review: 'I was looking for a low-ticket investment with assured returns. PACompany introduced me to Paradise Greens Plaza and it was a game changer. The rental income started from Day 1. The whole process was transparent and the team was available 24/7. Truly impressed!',
    rating: 5,
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    tag: 'Studio Apartment',
  },
  {
    id: 3,
    name: 'Amit Verma',
    role: 'Doctor',
    location: 'Ghaziabad',
    property: 'Bought – 3 BHK Villa, Lotus Greens Villa 2',
    review: 'After searching for months, PACompany found us the perfect 3 BHK at Lotus Greens Villa 2 within our budget. The Vastu-compliant design and proximity to hospitals was exactly what we needed. The team handled all paperwork without any hassle. Highly professional!',
    rating: 5,
    avatar: 'https://randomuser.me/api/portraits/men/55.jpg',
    tag: '3 BHK Villa',
  },
  {
    id: 4,
    name: 'Sunita Agarwal',
    role: 'Homemaker',
    location: 'Crossing Republic',
    property: 'Bought – 2 BHK Villa, Aalayam Srishti Villas',
    review: 'PACompany understood exactly what our family needed — a safe, gated community with schools and a park nearby. Aalayam Srishti Villas was the perfect fit. The agents were patient, honest and never pressured us. We moved in within 3 months of our first visit!',
    rating: 5,
    avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
    tag: '2 BHK Villa',
  },
  {
    id: 5,
    name: 'Vikram Singh',
    role: 'Investor',
    location: 'Delhi NCR',
    property: 'Invested – Farm Estate, Bollywood Aero City Farms',
    review: 'As an investor, I was looking for high-ROI opportunities near the new Jewar Airport. PACompany presented Bollywood Aero City Farms — 1000 sq yd estate at just ₹20K/sq.yd. The appreciation potential in this region is massive. Smart investment, great team!',
    rating: 5,
    avatar: 'https://randomuser.me/api/portraits/men/78.jpg',
    tag: 'Farm Estate',
  },
  {
    id: 6,
    name: 'Neha Kapoor',
    role: 'Teacher',
    location: 'Greater Noida West',
    property: 'Bought – 4 BHK Villa, Krishna Vatika',
    review: 'Being a first-time homebuyer, I was nervous about the whole process. The PACompany team held my hand through everything — loan assistance, site visits, legal checks. They got me a beautiful villa at the best possible price. Life-changing experience!',
    rating: 5,
    avatar: 'https://randomuser.me/api/portraits/women/22.jpg',
    tag: '4 BHK Villa',
  },
];

function StarRating({ rating }) {
  return (
    <div className="stars">
      {[1, 2, 3, 4, 5].map(s => (
        <i
          key={s}
          className={`fa fa-star ${s <= rating ? 'filled' : 'empty'}`}
        />
      ))}
    </div>
  );
}

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const [animDir, setAnimDir] = useState('next');

  const goTo = (idx, dir = 'next') => {
    setAnimDir(dir);
    setCurrent(idx);
  };

  const next = useCallback(() => {
    goTo((current + 1) % testimonials.length, 'next');
  }, [current]);

  const prev = () => {
    goTo((current - 1 + testimonials.length) % testimonials.length, 'prev');
  };

  useEffect(() => {
    if (paused) return;
    const t = setInterval(next, 4500);
    return () => clearInterval(t);
  }, [paused, next]);

  const t = testimonials[current];

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">

        {/* Header */}
        <div className="testimonials-header">
          <div className="test-label">
            <span className="test-label-dot" />
            Client Stories
          </div>
          <h2>What Our Clients Say</h2>
          <p>Real experiences from real homeowners & investors who trusted PACompany</p>
          <div className="test-divider">
            <span /> <i className="fa fa-star" /> <span />
          </div>
        </div>

        {/* Main Card */}
        <div
          className="test-main-wrapper"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          {/* Prev Button */}
          <button className="test-arrow left" onClick={prev} aria-label="Previous">
            <i className="fa fa-chevron-left" />
          </button>

          <div className={`test-card test-${animDir}`} key={t.id}>
            {/* Quote icon */}
            <div className="test-quote-icon">
              <i className="fa fa-quote-left" />
            </div>

            {/* Property tag */}
            <div className="test-property-tag">
              <i className="fa fa-home" /> {t.property}
            </div>

            {/* Review text */}
            <p className="test-review">"{t.review}"</p>

            {/* Stars */}
            <StarRating rating={t.rating} />

            {/* Client info */}
            <div className="test-client">
              <div className="test-avatar-wrap">
                <img src={t.avatar} alt={t.name} className="test-avatar" />
                <div className="test-avatar-ring" />
              </div>
              <div className="test-client-info">
                <strong>{t.name}</strong>
                <span>{t.role}</span>
                <span className="test-location">
                  <i className="fa fa-map-marker-alt" /> {t.location}
                </span>
              </div>
              <div className="test-tag-badge">{t.tag}</div>
            </div>
          </div>

          {/* Next Button */}
          <button className="test-arrow right" onClick={next} aria-label="Next">
            <i className="fa fa-chevron-right" />
          </button>
        </div>

        {/* Dots & Thumbnails */}
        <div className="test-controls">
          <div className="test-dots">
            {testimonials.map((_, i) => (
              <button
                key={i}
                className={`test-dot ${i === current ? 'active' : ''}`}
                onClick={() => goTo(i, i > current ? 'next' : 'prev')}
                aria-label={`Go to testimonial ${i + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Thumbnail strip */}
        <div className="test-thumbs">
          {testimonials.map((item, i) => (
            <button
              key={item.id}
              className={`test-thumb ${i === current ? 'active' : ''}`}
              onClick={() => goTo(i, i > current ? 'next' : 'prev')}
              aria-label={item.name}
            >
              <img src={item.avatar} alt={item.name} />
              <span>{item.name.split(' ')[0]}</span>
            </button>
          ))}
        </div>

        {/* Stats strip */}
        <div className="test-stats">
          <div className="test-stat">
            <strong>2,400+</strong>
            <span>Happy Clients</span>
          </div>
          <div className="test-stat-sep" />
          <div className="test-stat">
            <strong>4.9 / 5</strong>
            <span>Average Rating</span>
          </div>
          <div className="test-stat-sep" />
          <div className="test-stat">
            <strong>98%</strong>
            <span>Would Recommend</span>
          </div>
          <div className="test-stat-sep" />
          <div className="test-stat">
            <strong>15+ Yrs</strong>
            <span>Of Trust</span>
          </div>
        </div>

      </div>
    </section>
  );
}
